import { FC } from "react"
import { DLMLabel } from "../_models"
import { DetailCard, DetailItem, DetailLabelKeysToCells } from "../../../../components/layout"
import { ApplicationStateCell, PageViewLink } from "../../../../components/widgets"


type Props = {
  details: DLMLabel
}

const PROJECT_DETAIL_FIELDS = {
  projectName: 'Project Name / Location',
  planNo: "SCDF Building Plan No",
  otherRef: "Other Reference",
}


const DLMLabelDetailsCard: FC<Props> = ({details}) => {


    return(
    <>
    <div className="d-flex flex-row flex-wrap gap-6 mb-4">
      <DetailCard cardTitle="Label Details">
        <DetailItem labelText="Serial Number" content={`${details.serialNumber}`} />   
          
        <DetailItem labelText="Status">   
          <ApplicationStateCell state_val={details.state} />
        </DetailItem>           
        {DetailLabelKeysToCells(PROJECT_DETAIL_FIELDS, details.dlmRoiDetails.roi)}
        { (details?.disclaimerAck) && 
        <DetailItem labelText="Disclaimer Acknowledged" >
          <div className='form-check form-check-sm form-check-custom form-check-solid'>
            <input className='form-check-input pe-none' type='checkbox' checked readOnly />
          </div>
        </DetailItem>
        }                        
        { (details?.dlmRoiDetails && details.dlmRoiDetails?.roi && details.dlmRoiDetails.roi?.id) && 
        <>
        <div className='separator border-gray-200 mb-2'></div>
        <DetailItem labelText="ROI Number">      
            {(details.dlmRoiDetails.roi?.cbRef && details.dlmRoiDetails.roi.cbRef.length > 0) && 
            <>
            {details.dlmRoiDetails.roi.cbRef}
            &nbsp;
            </>
            }        
            <PageViewLink id={details.dlmRoiDetails.roi.id} pageType="dlmROI">(view)</PageViewLink>
        </DetailItem>
        </>    
        }    
      </DetailCard>
    </div>
    </>
    )
}

export { DLMLabelDetailsCard }